import {ArtifactsController} from '@mintdata-wsp/common/controllers/artifacts/ArtifactsController';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';
import {PubApplicationContextController} from '@mintdata-wsp/pub/controllers/context/PubApplicationContextController';
import {DesignController} from '@mintdata-wsp/pub/controllers/DesignController';
import {PubFlowCloudController} from '@mintdata-wsp/pub/controllers/flow/PubFlowCloudController';
import {PubFlowController} from '@mintdata-wsp/pub/controllers/flow/PubFlowController';
import {IntegrationController} from '@mintdata-wsp/pub/controllers/IntegrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

export class PubControllers
{
    public readonly integration:IntegrationController = new IntegrationController();
    // public readonly codeLoader:CodeLoaderController = new CodeLoaderController();
    public readonly design:DesignController = new DesignController();
    public readonly flow:PubFlowController = new PubFlowController();
    public readonly flowCloud:PubFlowCloudController = new PubFlowCloudController();

    private _initialized:boolean = false;

    public initialize()
    {
        WindowLocationUtil.setDocumentDomain();

        Assert.no(this._initialized);

        commonControllers.initialize({
            flow: this.flow,
            flowCloud: this.flowCloud,
            artifacts: new ArtifactsController(/**new VisualComponentsLoaderPublish()**/),
            context: new PubApplicationContextController()
        });

        commonControllers.hostContext.init();

        this.integration.init();

        commonControllers.buildVersion.init();

        commonControllers.spreadsheets.main.init();
        // commonControllers.spreadsheets.cloudSheet.init();
        commonControllers.spreadsheets.clientFunctions.init();

        this.integration.init();
        //TODO: this might get needed again, once SSR is needed/fixed
        // this.codeLoader.init();
        this.flow.init();
        this.flowCloud.init();
        if( this.integration.isStandaloneMode )
        {
            console.log('Standalone mode. Websocket connection to hippo will not be established');
        }
        else
        {
            // hippoAPI.init();
        }
        this._initialized = true;
    }
}

export const pubControllers:PubControllers = new PubControllers();
